<template>
  <div class="partial-collapse-container">
    <div class="partial-collapse collapse" :class="{'show': this.isTextExpanded}">
      <slot></slot>
    </div>
    <div class="text-center" style="display: block; position: relative" :style="hidingButtonStyle">
      <a data-toggle="collapse" role="button" :aria-expanded="this.isTextExpanded" @click="onClick" v-text="actionButtonText"></a>
    </div>
  </div>
</template>
<script>
  // import Translations from "./insert-me-to-translate.vue";

  export default {
    data() {
      return {
        'isTextExpanded': false
      }
    },
    created() {
      this.i18n = {
        'showMoreText': this.title(gettext('Show more')),
        'showLessText': this.title(gettext('Show less')),
      }
    },
    computed: {
      actionButtonText(){
        return this.isTextExpanded ? this.i18n.showLessText : this.i18n.showMoreText;
      },
      hidingButtonStyle(){
        const def = {
          'top': "0px",
          'padding-top': "20px"
        }
        if (this.isTextExpanded) return def;

        def['background'] = 'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1))';
        def['top'] = '-40px';
        def['padding-top'] = '50px'

        return def;
      }

    },
    methods: {
      onClick(){
        this.isTextExpanded = !this.isTextExpanded;
      },
      title(str){
        return str.charAt(0).toUpperCase() + str.slice(1);
      }
    }
  };
</script>
